module.exports = __webpack_public_path__ + "static/img/barra_11.d6e9009.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/barra_11.png
// module id = XdMc
// module chunks = 1